import * as React from "react";
import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import WindowDimensionsContext from "./WindowDimensionsContext";
const getWindowDimension = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
};
const useWindowDimension = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimension());
  useEffect(() => {
    const handleWindowResize = debounce(() => setWindowDimensions(getWindowDimension()), 200);
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  return windowDimensions;
};
const WindowDimensionsContextProvider = ({ children }) => {
  const windowDimensions = useWindowDimension();
  return /* @__PURE__ */ React.createElement(WindowDimensionsContext.Provider, { value: windowDimensions }, children);
};
export default WindowDimensionsContextProvider;
